/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, {  useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    string, bool, shape, number, object,
} from 'prop-types';

import { useSelector } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';
import ShopperApprovedReviewIcon from './Partials/ShopperApprovedReviewIcon/ShopperApprovedReviewIcon';
import ResponsiveImage from '../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';
import { getFeatureFlag } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import {  getDonationsCategory, getSSRDeviceType } from '../../../../../../state/ducks/App/App-Selectors';
import { transformCharacters } from '../../../../../helpers/markdown/characterTransformer';
import ProductReview from '../ProductReview';
import useIsDisplayChannel from '../../../../../helpers/hooks/useIsDisplayChannel';
import { CrossMerch } from '../../../CrossMerchContainer/CrossMerchContainer';

const useStyles = makeStyles((theme) => ({
    passportEligibleImage: {
        width: '24%',
        [theme.breakpoints.down('md')]: {
            width: '45%',
            marginBottom: '10px',
        },
        [theme.breakpoints.down(600)]: {
            display: 'block',
            width: '38%',
            margin: '0 auto 5px',
        },
    },
    plaEnabledProductTitle: {
        display: 'block',
        justifyContent: 'space-between',
        [theme.breakpoints.down(600)]: {
            display: 'flex',
            alignItems: 'center',
            padding: '0 20px',
        },
    },
    simpleProductTitle: {
        display: 'flex',
        flexDirection: 'column',
    },
    plaEnabledPassportImage: {
        width: '170px',
        [theme.breakpoints.down('md')]: {
            width: '45%',
        },
        [theme.breakpoints.down(600)]: {
            width: '100%',
        },
    },
    productName: {
        width: '100%',
        marginTop: 0,
        fontSize: '24px',
        marginBottom: '16px',
        '& sup': {
            fontSize: '0.8rem',
            display: 'inline',
        },
        [theme.breakpoints.down('md')]: {
            marginBottom: '10px',
        },
        [theme.breakpoints.down(600)]: {
            display: 'none',
        },
    },
    foodProductName: {
        [theme.breakpoints.down(767)]: {
            display: 'block',
        },
    },
    passportProductName: {
        margin: 0,
        [theme.breakpoints.down(600)]: {
            display: 'none',
        },
    },
    sellerName: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        [theme.breakpoints.down(600)]: {
            marginTop: 0,
            textAlign: 'center',
        },
        '& span': {
            fontWeight: 'bold',
        },
    },
    plaThreeTitle: {
        [theme.breakpoints.up(1024)]: {
            fontSize: '2em !important',
            width: '100% !important',
        },
    },
    widthForNewUpsellDesign: {
        '@media (min-width: 1280px)': {
            width: '70%',
            fontSize: '32px',
            lineHeight: '45px',
            marginBottom: '8px',
        },
        '@media (min-width: 1024px) and (max-width: 1280px)': {
            width: '65%',
            fontSize: '24px',
            lineHeight: '45px',
            marginBottom: '8px',
        },
        '@media (min-width: 768px) and (max-width: 1024px)': {
            marginBottom: '2px',
        },
        '@media (min-width: 600px) and (max-width: 768px)': {
            marginBottom: '2px',
        },

    },
    priceContainer: {
        display: 'flex',
        fontSize: '1.50rem',
        lineHeight: '2.5rem',
        fontFamily: 'Area Variable, LatoRegular',
        '@media (max-width: 600px)': {
            fontSize: '1.25rem',
            lineHeight: '1.875rem',
        },
    },
    crossedOutRetailPrice: {
        textDecoration: 'line-through',
        fontWeight: '400',
    },
    salePrice: {
        color: theme.palette.pdp.salePrice || '#a1001a',
        fontWeight: 700,
        marginLeft: '20px',
    },
    price: {
        color: theme.palette.cms?.black || '#2f2f2f',
        fontWeight: 700,
        fontSize: '1.50rem',
        lineHeight: '2.5rem',
        fontFamily: 'Area Variable, LatoRegular',
        '@media (max-width: 600px)': {
            fontSize: '1.25rem',
            lineHeight: '1.875rem',
        },
    },
    availabilityMessage: {
        textTransform: 'capitalize',
        display: 'block',
    },
    plaSellerName: {
        margin: '0px',
    },
    shipmentMessage: {
        fontSize: '16px',
        lineHeight: '18px',
        textTransform: 'capitalize',
        color: theme.palette.upsellsTextColor || '#2F2F2F',
        margin: '6px 0px 18px',
    },
    shipmentMessageFuture: {
        fontFamily: 'Area Variable, LatoBold',
        color: theme.palette.upsellsFutureAvailabilityColor || '#A2011A',
    },
    productHeading: {
        '& $productName': {
            fontSize: '32px',
            lineHeight: '37px',
            padding: '0px 16px 0px 24px',
            fontWeight: '700',
            fontFamily: 'Area Variable, LatoBold',
            [theme.breakpoints.down('600')]: {
                fontSize: '24px',
                lineHeight: '36px',
                padding: '0px 16px',
            },
        },
        '& $widthForNewUpsellDesign': {
            '@media screen and (min-width: 600px)': {
                width: '100%',
                padding: '0px',
                lineHeight: '37px',
                marginBottom: '0px',
            },

        },
    },
    productTitleTop: {
        [theme.breakpoints.down('600')]: {
            '& $productName': {
                fontSize: '24px',
                padding: '0px 16px 0px 16px',
                lineHeight: '28px',
                display: 'block',
            },
        },
        '& $sellerName': {
            padding: '8px 16px 0px 24px',
            [theme.breakpoints.down('600')]: {
                textAlign: 'left',
                padding: '0px 16px',
                lineHeight: '24px',
            },
        },
    },
    plaProductTitle: {
        '& $productName , $h1': {
            padding: '0px',
            margin: '0px',
            display: 'block',
            lineHeight: '25px',
            fontSize: '20px !important',
            '@media screen and (max-width: 600px)': {
                lineHeight: '23px',
                fontSize: '18px',
            },
        },
    },
    plaProductTitleVariantB: {
        '& $productName': {
            padding: '0px',
            margin: '0px',
            display: 'block',
            lineHeight: '25px',
            fontSize: '20px',
        },
    },
}));

const ProductTitle = ({
    isPlaEnabled,
    presentationFamily,
    productName,
    isPassportBannerEnabled,
    skuEnabledOnMobile,
    selectedSku,
    productBrandId,
    skuCount,
    product,
    featureFlags,
    productUrl,
    isPdpRedesignEnabled,
    showProductTitleTop,
    isPlaRedesignEnabled,
    isPdpRedesignSkuEnabled,
    showShopName,
}) => {
    const classes = useStyles();
    const { featureFlags: flags = {} } = useContext(CrossMerch);
    const sellerNameEnabled = useSelector(getFeatureFlag('is-seller-name-shown'));
    const isSmallerDevice = useMediaQuery('(max-width: 767px)');
    const adjustTablet = useMediaQuery('(max-width: 767px) and (min-width:600px)') && isPdpRedesignSkuEnabled && skuCount > 1;

    const sellerName = showShopName ? selectedSku?.marketplaceShopDetails?.shopName || '' : '';
    let newPdpStyle =  '';
    if (isPlaRedesignEnabled) {
        newPdpStyle = `${classes.productHeading} ${classes.plaProductTitle}`;
    } else if (showProductTitleTop) {
        newPdpStyle = `${classes.productHeading} ${classes.productTitleTop}`;
    } else if (isPdpRedesignEnabled) {
        newPdpStyle = classes.productHeading;
    }
    const foodBrandClass = (presentationFamily === 'food' && skuEnabledOnMobile) ? classes.foodProductName : '';
    const donationsCategoryName = useSelector(getDonationsCategory);
    const ssrDeviceType = useSelector(getSSRDeviceType);
    const foodPlaRedesign = useSelector(getFeatureFlag('which-food-pla-design'));
    const isDisplayChannel = useIsDisplayChannel();

    const isPmallPersonalizationAttr = (selectedSku?.attributes || [])?.find((attr) => attr.name === 'is_pmall_personalization_enabled');
    const isPmallPersonalizationEnabled = isPmallPersonalizationAttr?.values?.[0]?.value === 'true';

    // Ensure the name is not updated unnecessarily
    const [transformedName, setTransformedName] = useState(productName);

    // PowerReviews Flags
    const isPDPReviewsEnabled = useSelector(getFeatureFlag(['is-pdp-reviews-enabled']));
    const isPowerReviewEnabled = useSelector(getFeatureFlag(['is-power-review-enabled']));

    useEffect(() => {
        // The name styles kept glitching on hover, this ensures these functions are only called when the name changes
        setTransformedName(transformCharacters(productName));
    }, [productName]);

    const renderPassportImage = () => {
        if (presentationFamily === 'flower' && isPassportBannerEnabled && donationsCategoryName?.toLowerCase() !== 'donations') {
            return (
                <ResponsiveImage
                    className={isPlaEnabled ? classes.plaEnabledPassportImage : classes.passportEligibleImage}
                    path="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt8d4549d3cac15860/61e09d4f2e109d6c649d4aa4/PP_EligibleIcon.svg"
                    alt="Passport Eligible"
                />
            );
        }
        return null;
    };

    // Removing this design from any feature and abtest
    const isNewUpsell = presentationFamily === 'food';
    const isPmallProduct = featureFlags['is-pmall-pdp-template-enabled'] && (productBrandId === '1030' || productBrandId === '1033') &&  isPmallPersonalizationEnabled;
    if (skuEnabledOnMobile && isNewUpsell && isSmallerDevice && (skuCount <= 1 || adjustTablet) && !isPmallProduct && !isPlaRedesignEnabled) {
        // to avoid duplicate render for new design and single sku layout
        return <></>; // Product title file is render from different file
    }
    const retialPrice = selectedSku?.prices?.[0]?.value || '';
    const salePrice = selectedSku?.prices?.[1]?.value || '';
    const isShipNow = product?.availability?.deliveryMessage === 'AVAILABLE TO SHIP NOW';
    const isPlaThreeColumn = (isPlaEnabled || isDisplayChannel) && foodPlaRedesign === 'three_column';
    return (
        <>
            <div data-id={isPlaThreeColumn ? 'three_column_pla_title' : 'product_title'} className={(isPlaEnabled || isDisplayChannel) && !isPlaRedesignEnabled ? classes.plaEnabledProductTitle : `${classes.simpleProductTitle} ${newPdpStyle}`} aria-hidden="true">

                <h1 className={(isPlaEnabled || isDisplayChannel) && !isPassportBannerEnabled ? `${isPlaThreeColumn ? classes.plaThreeTitle : ''} ${classes.passportProductName} ${foodBrandClass}` : `${classes.productName}  ${foodBrandClass} ${isNewUpsell && !isPlaThreeColumn ? classes.widthForNewUpsellDesign : ''}`}>{transformedName}</h1>
                {flags['is-pdp-qty-availability-enabled'] && <div className={`${classes.shipmentMessage} ${!isShipNow ? classes.shipmentMessageFuture : ''}`} availability="">{product?.availability?.deliveryMessage?.toLowerCase?.()}</div>}
                {
                    isPlaThreeColumn && isPDPReviewsEnabled && isPowerReviewEnabled && !isPlaRedesignEnabled && (
                        <ProductReview
                            product={product}
                            selectedSku={selectedSku}
                            productUrl={productUrl}
                            isPosition
                            noRender={false}
                        />
                    )
                }
                {sellerNameEnabled && sellerName && (productBrandId === '1026' || productBrandId === '1027') && <p className={isPlaEnabled ? `${classes.plaSellerName} ${classes.sellerName}` : classes.sellerName}>Created & Shipped By: <span>{sellerName}</span></p>}
                {isPlaEnabled && !isPdpRedesignEnabled  && ssrDeviceType !== 'mobile' && !isPlaRedesignEnabled && renderPassportImage()}
                {(isPlaEnabled || (isDisplayChannel && !isNewUpsell)) && foodPlaRedesign !== 'three_column' && !isPlaRedesignEnabled && <ShopperApprovedReviewIcon />}
                {isPmallProduct
                && (
                    <div>
                        {isPDPReviewsEnabled && isPowerReviewEnabled && (
                            <ProductReview
                                product={product}
                                selectedSku={selectedSku}
                                productUrl={productUrl}
                                isPosition
                            />
                        )}
                        {product?.availability?.deliveryMessage && <span className={classes.availabilityMessage}>{product?.availability?.deliveryMessage?.toLowerCase?.()}</span>}
                        {retialPrice > salePrice
                            ? (
                                <div className={classes.priceContainer}>
                                    <s>
                                        ${retialPrice}
                                    </s>
                                    <span className={classes.salePrice}>
                                        ${salePrice}
                                    </span>
                                </div>
                            )
                            : (
                                <span className={classes.price}>
                                    ${retialPrice}
                                </span>
                            )}
                    </div>
                )}
            </div>
            {!isPlaEnabled && !isPdpRedesignEnabled && ssrDeviceType !== 'mobile' && renderPassportImage()}
        </>
    );
};

ProductTitle.propTypes = {
    isPassportBannerEnabled: bool.isRequired,
    isPlaEnabled: bool.isRequired,
    presentationFamily: string.isRequired,
    productName: string.isRequired,
    skuEnabledOnMobile: bool,
    selectedSku: shape({
        marketplaceShopDetails: shape({
            shopName: string,
        }),
    }),
    productBrandId: string,
    skuCount: number,
    featureFlags: object,
    product: object,
    productUrl: string,
    isPdpRedesignEnabled: bool,
    showProductTitleTop: bool,
    isPlaRedesignEnabled: bool,
    isPdpRedesignSkuEnabled: bool,
    showShopName: bool,
};

ProductTitle.defaultProps = {
    skuEnabledOnMobile: false,
    selectedSku: {},
    productBrandId: '',
    skuCount: 0,
    featureFlags: {},
    product: {},
    productUrl: '',
    isPdpRedesignEnabled: false,
    showProductTitleTop: false,
    isPlaRedesignEnabled: false,
    isPdpRedesignSkuEnabled: false,
    showShopName: false,
};

export default ProductTitle;
